// extracted by mini-css-extract-plugin
module.exports = {"notification":"Notification_notification__oIVQZ","error":"Notification_error__1WP--","success":"Notification_success__FFhvu"};